import {
  ResponsiveContainer,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Tooltip,
} from "recharts";

const SeveridadePorEmbalagemRadar = ({ data, height = 320 }) => {
    
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RadarChart data={data}>
        <PolarGrid />
        <PolarAngleAxis dataKey="name" />
        <PolarRadiusAxis />
        <Tooltip
          formatter={(value) => [`${value} NCEs`, "Ocorrências"]}
          contentStyle={{ fontSize: 12 }}
        />
        <Radar
          name="Ocorrências"
          dataKey="value"
          stroke="#5bc0de"
          fill="#5bc0de"
          fillOpacity={0.5}
        />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default SeveridadePorEmbalagemRadar;
